import { authenticatedFetch } from "utils/authenticatedFetch";
import URL from "./apiURL";

export async function syncBauTeamdetails(payload) {
  try {
    const res = await authenticatedFetch(URL.syncBauTeamDetails, {
      method: "PUT",
      body: JSON.stringify(payload)
    });
    return res.data;
  } catch (error) {
    console.error("Error updating the BAU Team details:", error);
    throw error;
  }
}
